module.exports = __webpack_public_path__ + "img/icon-arrow-down-dark.21dc6b1b.svg";